import { useRef } from "react";
import { Avatar, Box } from "@mui/material";
import { InputFileInterface } from "../interfaces/firmaInterfaces";

export const InputFile = ({
  accept,
  name = "",
  nameFile = "",
  helperText = "",
  icon,
  disabled = false,
  handleChangeInputFile,
}: InputFileInterface) => {
  const cerKeyRef = useRef<HTMLInputElement>(null);

  const handleSelectFile = () => {
    if (disabled) return;
    cerKeyRef.current!.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        paddingX: 3,
        paddingY: 0.6,
        border: 1,
        borderRadius: 1,
        borderColor: "divider",
        width: "100%",
        justifyContent: "space-between",
        cursor: "pointer",
      }}
      onClick={() => handleSelectFile()}
    >
      <Avatar sx={{ width: 30, height: 30 }}>
        <input
          name={name}
          hidden
          type="file"
          ref={cerKeyRef}
          onChange={(e) => handleChangeInputFile(e)}
          accept={accept}
        />
        {icon}
      </Avatar>
      {nameFile ? nameFile : helperText}
    </Box>
  );
};
